<div class="dialog">
    <div class="dialog-header">指派会签</div>
    <div class="dialog-body">
        <!-- 经办人和负责人部分（来自sp2） -->
        <div class="grid">
            <div class="row no-border">
                <div class="column no-border" [style.width]="'360px'">
                    选择主办部门经办人和负责人
                </div>
            </div>
            <!-- <div class="row">
                <div class="column background-page" [style.width]="'80px'">
                    主办部门
                </div>
                <div class="column text-left" [style.width]="'280px'">
                    {{no_1_DepartmentName}}
                </div>
            </div> -->
            <div class="row">
                <div class="column background-page" [style.width]="'80px'">
                    经办人2
                </div>
                <div class="column text-left" [style.width]="'80px'">
                    {{no_1_DepartmentName}}
                </div>
                <div class="column" [style.width]="'200px'">
                    <nz-select nzPlaceHolder="选择第2经办人（选填）" [(ngModel)]="no_2_userId" [nzAllowClear]="true">
                        <nz-option *ngFor="let user of userTreeNodesMap[no_1_DepartmentId.toString()]"
                            [nzLabel]="user.postName + '/' + user.name" [nzValue]="user.id"
                            [nzDisabled]="user.id!.toString() === no_10_userId.toString() || user.id!.toString() === no_9_userId.toString()">
                        </nz-option>
                    </nz-select>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="'80px'">
                    <span class="color-danger">*</span> 负责人1
                </div>
                <div class="column text-left" [style.width]="'80px'">
                    {{no_1_DepartmentName}}
                </div>
                <div class="column" [style.width]="'200px'">
                    <nz-select nzPlaceHolder="选择第1负责人（必填）" [(ngModel)]="no_10_userId" [nzAllowClear]="false">
                        <nz-option *ngFor="let user of userTreeNodesMap[no_1_DepartmentId.toString()]"
                            [nzLabel]="user.postName + '/' + user.name" [nzValue]="user.id"
                            [nzDisabled]="user.id!.toString() === no_9_userId.toString() || user.id!.toString() === no_2_userId.toString()">
                        </nz-option>
                    </nz-select>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="'80px'">
                    负责人2
                </div>
                <div class="column text-left" [style.width]="'80px'">
                    {{no_1_DepartmentName}}
                </div>
                <div class="column" [style.width]="'200px'">
                    <nz-select nzPlaceHolder="选择第2负责人（选填）" [(ngModel)]="no_9_userId" [nzAllowClear]="true">
                        <nz-option *ngFor="let user of userTreeNodesMap[no_1_DepartmentId.toString()]"
                            [nzLabel]="user.postName + '/' + user.name" [nzValue]="user.id"
                            [nzDisabled]="user.id!.toString() === no_10_userId.toString() || user.id!.toString() === no_2_userId.toString()">
                        </nz-option>
                    </nz-select>
                </div>
            </div>
        </div>

        <!-- 会签部门部分（来自sp2） -->
        <div class="grid">
            <div class="row no-border">
                <div class="column no-border" [style.width]="'100px'">

                </div>
                <div class="column no-border" [style.width]="'160px'">
                    选择会签部门
                </div>
                <div class="column no-border" [style.width]="'100px'">
                    <label>
                        <input type="checkbox" [(ngModel)]="noNeedRest">
                        <span class="{{noNeedRest ? 'color-primary' : ''}}">无需会签</span>
                    </label>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="'40px'">

                </div>
                <div class="column background-page" [style.width]="'120px'">
                    选择部门
                </div>
                <div class="column background-page" [style.width]="'200px'">
                    负责人
                </div>
            </div>
            <div class="row" *ngFor="let department of departments">
                <div class="column" [style.width]="'40px'">
                    <input type="checkbox" [(ngModel)]="department.checked" [disabled]="noNeedRest">
                </div>
                <div class="column {{department.checked ? 'color-primary' : ''}}  {{noNeedRest ? 'color-light' : ''}} text-left"
                    [style.width]="'120px'">
                    {{department.label}}
                </div>
                <div class="column" [style.width]="'200px'">
                    <select [(ngModel)]="selectedUserMap[department.value.toString()]">
                        <option *ngFor="let user of userTreeNodesMap[department.value.toString()]" [value]="user.id">
                            {{user.postName}}/{{user.name}}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <!-- 会签领导部分（来自sp1） -->
        <div class="grid">
            <div class="row no-border">
                <div class="column no-border" [style.width]="'360px'">
                    选择会签领导
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="'120px'">
                    分管副指挥长
                </div>
                <div class="column background-page" [style.width]="'240px'">
                    <select [(ngModel)]="no_11_UserId" disabled>
                        <option [value]="''" [disabled]="true">没有用户</option>
                        <option *ngFor="let user of subSu" [value]="user.id">
                            {{user.name}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="'120px'">
                    其他副指挥长1
                </div>
                <div class="column background-page" [style.width]="'240px'">
                    <select [(ngModel)]="no_12_UserId">
                        <option [value]="''">无需其他副指挥长签字</option>
                        <option *ngFor="let user of subSu" [value]="user.id"
                            [disabled]="user.id!.toString() === no_11_UserId.toString() || user.id!.toString() === no_13_UserId.toString()">
                            {{user.name}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="'120px'">
                    其他副指挥长2
                </div>
                <div class="column background-page" [style.width]="'240px'">
                    <select [(ngModel)]="no_13_UserId">
                        <option [value]="''">无需其他副指挥长签字</option>
                        <option *ngFor="let user of subSu" [value]="user.id"
                            [disabled]="user.id!.toString() === no_11_UserId.toString() || user.id!.toString() === no_12_UserId.toString()">
                            {{user.name}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="column background-page" [style.width]="'120px'">
                    指挥长
                </div>
                <div class="column background-page" [style.width]="'240px'">
                    <select [(ngModel)]="suUserId">
                        <option [value]="''">无需指挥长签字</option>
                        <option *ngFor="let user of su" [value]="user.id">
                            {{user.name}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
    </div>
    <div class="dialog-footer">
        <button nz-button nzType="default" (click)="cancel()">取消</button>
        <button nz-button nzType="primary" (click)="confirm()" [disabled]="!canConfirm">确定</button>
    </div>
</div>